import { IStateManagedEntity } from "../../helpers/state-helpers/state-action";
import { School } from "../school/school";
import { Teacher } from "../teacher/teacher";
import { Duration, DurationDto } from "./duration";
import { ScheduleLesson, ScheduleLessonDto } from "./lesson";

export type ScheduleDto = {
  id: string;
  duration: DurationDto[];
  lessons: ScheduleLessonDto[];
  teacherEmail: string;
  description?: string;
  classes: string[];
};

export class Schedule implements IStateManagedEntity {
  constructor(
    public id: string,
    public duration: Duration[],
    public lessons: ScheduleLesson[],
    public classes: string[],
    public teacher?: Teacher,
    public description?: string,
  ) {}

  static createFromScheduleDto(
    dto: ScheduleDto,
    teacher: Teacher,
    school: School,
  ) {
    return new Schedule(
      dto.id,
      dto.duration,
      dto.lessons.map((l) => {
        const subSchool = school.subSchools.find(
          (ss) => ss.subSchoolId === l.subSchoolId,
        );
        if (!subSchool) {
          throw Error(
            `A subschool with id ${l.subSchoolId} does not exist on school ${school.id}. School has following subschools: ${school.subSchools.map((ss) => ss.subSchoolId).join(", ")}`,
          );
        }
        return ScheduleLesson.fromScheduleLessonDto(l, subSchool);
      }),
      dto.classes,
      teacher,
      dto.description,
    );
  }
}
